var installedModules = {};
var moduleToHandlerMapping = {
	48430: {
		getter: () => (() => (__webpack_require__(96540))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^16.14.0",
			  "strictVersion": true,
			  "singleton": false,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react",
	},
	21754: {
		getter: () => (() => (__webpack_require__(38205))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "2.20.40",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "glamor",
	},
	76581: {
		getter: () => (() => (__webpack_require__(2543))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "4.17.21",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "lodash",
	},
	33426: {
		getter: () => (() => (__webpack_require__(40961))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^16.10.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dom",
	},
	27240: {
		getter: () => (() => (__webpack_require__(91028))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.26.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "launchdarkly-react-client-sdk",
	},
	38983: {
		getter: () => (() => (__webpack_require__(27389))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "5.1.0",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-redux",
	},
	4378: {
		getter: () => (() => (__webpack_require__(30250))),
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "npm:react-dnd@^11.1.3",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": true
			},
			scope: ["default"],
		},
		shareKey: "react-dnd-latest",
	}
};
var initialConsumes = [48430];
__webpack_require__.federation.installInitialConsumes = () => (__webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping:moduleToHandlerMapping,
	webpackRequire: __webpack_require__
}))
var chunkMapping = {
	"36": [
		38983,
		76581,
		21754,
		33426,
		27240
	],
	"256": [
		21754,
		33426,
		76581,
		27240
	],
	"319": [
		21754,
		33426
	],
	"328": [
		21754,
		38983,
		33426,
		76581,
		27240
	],
	"373": [
		21754,
		27240,
		33426,
		76581
	],
	"419": [
		21754,
		27240,
		33426,
		76581
	],
	"432": [
		21754,
		33426,
		76581,
		27240
	],
	"436": [
		38983,
		76581,
		33426,
		21754,
		27240
	],
	"541": [
		33426,
		21754,
		76581,
		27240
	],
	"570": [
		33426,
		21754,
		76581,
		27240
	],
	"673": [
		33426,
		76581,
		21754
	],
	"682": [
		27240,
		38983,
		21754,
		33426,
		76581
	],
	"725": [
		33426,
		76581,
		21754,
		27240
	],
	"729": [
		21754,
		33426,
		27240,
		76581,
		38983
	],
	"760": [
		21754,
		33426,
		76581,
		38983
	],
	"792": [
		38983,
		76581,
		33426,
		21754,
		27240
	],
	"831": [
		21754,
		76581
	],
	"833": [
		21754,
		33426
	],
	"847": [
		21754,
		27240,
		33426,
		4378,
		76581,
		38983
	],
	"880": [
		21754,
		33426
	],
	"887": [
		33426,
		21754
	],
	"941": [
		21754,
		33426,
		76581
	],
	"954": [
		48430
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}